// extracted by mini-css-extract-plugin
export default {"flows-overview":"FlowsOverview_flows-overview__ubeeW"};